export default function getResource(label, vars = []) {
    const resources = {
        nickname: 'Surnom',
        nicknameDescription: 'Votre pseudonyme sera affiché publiquement dans les commentaires des articles Sephora, les questions et réponses sur les articles et la galerie.'
    };
    return resources[label];
}
